import * as React from 'react';
import { CardContent } from '@mui/material';
import { contentCardContentCardMainFullBleed } from 'ui/dynamicContentCard/dynamicContentCardCssDefs';

interface Props {
  fullBleed?: boolean;
  className?: string;
}

export const DynamicContentCardContent: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  children,
  className = '',
  fullBleed = false,
}) => {
  return (
    <CardContent css={fullBleed && contentCardContentCardMainFullBleed} className={className}>
      {children}
    </CardContent>
  );
};
